import { StorePagination } from "../../../../DashboardPagination"
import { logActions } from "../../../../../store/log-slice"

const Pagination = ({ index }) => {
    return <StorePagination index={index} sliceName="log" actions={logActions} label="Logs Seitennavigation" />
}

export default Pagination;
